// extracted by mini-css-extract-plugin
export var bounce = "_i4-1";
export var generatingText = "_i4-6";
export var lightning = "_i4-4";
export var popup = "_i4-5";
export var progressBar = "_i4-7";
export var progressFill = "_i4-8";
export var progressShimmer = "_i4-9";
export var progressText = "_i4-a";
export var shimmer = "_i4-3";
export var uploadIcon = "_i4-0";
export var uploadingText = "_i4-2";